import { Serializer } from '@niknevis/serializer'
import * as yup from 'yup'
import { MESSAGES } from '@/modules/common/core/boot/validations'
import { isMimeType } from '@/modules/shared/helpers/mime-types'

interface IAttachment {
  id: number
  name: string
  full_name: string
  url: string
  size: number
  mime_type: string
  created_at: Date
  __isAttachment: true
}

export class AttachmentSerializer extends Serializer<File, File, IAttachment> {
  static $isPrimitive = true

  static fileTypes = [
    'jpg',
    'bmp',
    'png',
    'html',
    'pdf',
    'docx',
    'doc',
    'xls',
    'csv',
    'zip',
    'rar'
  ]

  static checkMimeTypes(fileType: string) {
    return this.fileTypes.some(type => isMimeType(fileType, type))
  }

  static getFields() {
    return yup.mixed().test({
      message: MESSAGES.FILE_TYPE,
      test: value => {
        return value instanceof File && this.checkMimeTypes(value.type)
      }
    })
  }

  static isAttachment(data: any) {
    return data.__isAttachment
  }

  __isAttachment = true

  protected serialize(data: any): any {
    return data
  }

  protected deserialize(data: any): any {
    return data
  }
}
